import React from "react"
import Paper from "material-ui/Paper"
import UserForm from "../UserForm"
import SelfServiceWebPunch from "./SelfServiceWebPunch"
import { IUserDocument, ELoggedInUserType } from "../../../../models"
import SelfServiceLeaveDashboard from "./SelfServiceLeaveDashboard"
import AccountStore from "../../../../stores/AccountStore"
import UserDetailChartSummary from "../UserDetailChartSummary"
import { grey50 } from "material-ui/styles/colors"
interface IProps {
  user: IUserDocument
  loggedInUserType: ELoggedInUserType
  reloadTimecard(): void
}

const SummaryForSelfService: React.SFC<IProps> = (props: IProps) => {
  return (
    <Paper
      zDepth={1}
      style={{ display: "flex", margin: 20, position: "relative", overFlow: "hidden", minWidth: 1000 }}
    >
      <div style={{ flex: 5 }}>
        <SelfServiceWebPunch
          user={props.user}
          reloadTimecard={props.reloadTimecard}
        />
      </div>
      <div style={{ flex: 7, padding: 20, background: grey50 }}>
        <UserForm readonly user={props.user} loggedInUserType={ELoggedInUserType.Employee} />
      </div>
      <div style={{ flex: 7, padding: "20px 0" }} className="WrapperUserDetailChartSummary">
        {AccountStore.getAccrualsTimeoffEnabled() ?
          <SelfServiceLeaveDashboard
            user={props.user}
            loggedInUserType={props.loggedInUserType}
          /> :
          <UserDetailChartSummary
            user={props.user}
          />
        }
      </div>
    </Paper>
  )
}

export default SummaryForSelfService